import { useGame } from '../../../data/gameContext';
import { getItemDetails } from '../../../data/inventory/gameItems';
import '../basePanel.css';
export default function BasePanelInventory(){
    const { gameState, getGameTime, updateGameState } = useGame(); 

    // TODO: strip out inline to css when finsihed.
    // TODO: based on item type call a function to get the item details, and maybe an icon.
    // TODO: find best way to fit a good amount of items on the screen.
    // TODO: does the player need to be able to use items from the inventory?
    // TODO: popover to view details on hover.
    // TODO: should the inventory have different views, weapons, consumables, etc.

    return (
        <div className="basePanel-generic">
            <h2>Inventory</h2>
            <table style={{ width: '98%', borderCollapse: 'collapse', marginLeft: '4px', marginRight: '4px' }}>
            <thead>
                <tr>
                <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Item Name</th>
                <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Quantity</th>
                </tr>
            </thead>
            <tbody>
                {gameState.PlayerCharacter && gameState.PlayerCharacter.Inventory.map((item, index) => {
                const itemDetails = getItemDetails(item.Id);
                return (
                    <tr key={index}>
                    <td style={{ border: '1px solid #ddd', padding: '8px', alignContent: 'flex-start' }}>{itemDetails?.Name}</td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.Quantity}</td>
                    </tr>
                );
                })}
            </tbody>
            </table>
        </div>
    );
}